import { render, staticRenderFns } from "./PointsHistory.vue?vue&type=template&id=1af3bdbc&scoped=true"
import script from "./PointsHistory.vue?vue&type=script&lang=ts"
export * from "./PointsHistory.vue?vue&type=script&lang=ts"
import style0 from "./PointsHistory.vue?vue&type=style&index=0&id=1af3bdbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af3bdbc",
  null
  
)

export default component.exports